import React from 'react';
import { useSelector } from 'react-redux';

import InnerTabsForBuyerDesign from '@features/costing/components/InnerTabsForBuyerDesign';
import ParentTabsForAdminRole from '@features/costing/components/ParentTabsForAdminRole';
import ParentTabsForFashionDesigner from '@features/costing/components/ParentTabsForFashionDesigner';
import TopFilter from '@features/costing/components/TopFilter';

import { checkAnyUserType, checkUserType } from '@utils/Util';

const CostingListTopFilter = ({ toggleFilter }) => {
	let filterfields = useSelector((store) => store.filterFieldStore);
	const activeTab = filterfields['status'] && filterfields['status'][0]?.value;
	const completedTab = filterfields['status'] && filterfields['status'][0]?.subStatus;
	const acceptedRoles = ['COSTING_MANAGER', 'ADMIN', 'MANAGEMENT', 'SUPPLY_CHAIN'];

	const renderTabs = () => {
		switch (true) {
			case checkAnyUserType(acceptedRoles):
				return <ParentTabsForAdminRole />;
			case !checkUserType('FASHION_DESIGNER'):
				return <InnerTabsForBuyerDesign />;
			default:
				return <ParentTabsForFashionDesigner />;
		}
	};

	return (
		<>
			<div className="top-header bg-white costing-top-header">
				<div className="page-title-area">
					<h1 className="semibold-16">Costing</h1>
				</div>
				<div className="navigation-tab shadow-nav-4dp">{renderTabs()}</div>
				<TopFilter
					managerType="COSTING_MANAGER"
					statusType={activeTab}
					completedTab={completedTab}
					toggleFilter={toggleFilter}
				/>
			</div>
		</>
	);
};

export default CostingListTopFilter;
